import { useNode } from "@craftjs/core";
import React from "react";

import {
  PencilActiveIcon,
  PaintIcon,
  JustifyIcon,
  JustifyActiveIcon,
  LeftALignIcon,
  LeftALignActiveIcon,
  CenterAlignIcon,
  CenterAlignActiveIcon,
  RightAlignIcon,
  RightAlignActiveIcon,
  StaplesActiveIcon,
  SettingsIcon,
} from "../../../assets/ui-icons";
import { isUpdatedFromDefault } from "../../utils";
import { IconPack } from "../../../assets/icon-pack";

import {
  ColorInput,
  Panel,
  SpacerInput,
  ToggleInput,
  OptionsInput,
  PaddingInput,
  RangeInput,
  Tabs,
} from "./../../ui-kit";
import { socialMedia } from "./socialMedia";
import TextInput from "../../ui-kit/text";
import RightBar from "../../ui-kit/rightbar";
import { INPUT_LIMITS } from "../../input-limits";
export const CMSSocialLinksSettings = () => {
  const {
    actions: { setProp },
    props,
    id,
  } = useNode((node) => ({
    text: node.data.props.text,
    props: node.data.props,
  }));

  const {
    icons = [],
    links = {},
    layoutPadding = {
      top: "8px",
      bottom: "8px",
      left: "10px",
      right: "10px",
    },
    iconSize = "25px",
    color,
    backgroundColor,
    gapX = "6px",
    align,
    openInNewTab = false,
    showLabel = false,
    isSocialShare = false,
  } = props;

  const addIcon = (iconId) => {
    var tempIcons = [...icons];

    if (!tempIcons.includes(iconId)) {
      tempIcons.push(socialMedia[iconId].id);

      setProp((props) => {
        props.icons = tempIcons;
      });
    }
  };

  const removeIcon = (iconId) => {
    var tempIcons = [...icons];
    tempIcons = tempIcons.filter((id) => id !== iconId);
    setProp((props) => {
      props.icons = tempIcons;
    });
  };
  const SocialMediaLinksPicker = () => {
    return (
      <div className="flex flex-wrap justify-center gap-2">
        {Object.keys(socialMedia).map((item, i) => {
          return (
            <span
              onClick={(e) => {
                if (icons.includes(item)) removeIcon(item);
                else addIcon(item);
              }}
              key={`${socialMedia[item].name}-${i}`}
              className={`flex justify-center items-center w-7 h-7 px-auto py-auto rounded-full text-ui-blue cursor-pointer ${
                icons.includes(item) ? "bg-gray-100" : ""
              }`}
            >
              {socialMedia[item].icon}
            </span>
          );
        })}
      </div>
    );
  };

  const General = () => {
    return (
      <>
        <SpacerInput>
          <SocialMediaLinksPicker />
          <RangeInput
            resetValue={25}
            value={iconSize}
            onChange={(val) => {
              setProp((props) => {
                props.iconSize = val + "px";
              });
            }}
            label={"Size"}
            min={INPUT_LIMITS["cms-font-size"].min}
            max={INPUT_LIMITS["cms-font-size"].max}
            step={INPUT_LIMITS["cms-font-size"].step}
          />
          <RangeInput
            resetValue={6}
            value={gapX}
            onChange={(val) => {
              setProp((props) => {
                props.gapX = val + "px";
              });
            }}
            label={"Gap"}
            min={INPUT_LIMITS["cms-gap"].min}
            max={INPUT_LIMITS["cms-gap"].max}
            step={INPUT_LIMITS["cms-gap"].step}
          />
          <OptionsInput
            label={"Alignment"}
            value={align}
            onChange={(val) => {
              setProp((props) => {
                props.align = val;
                props.textAlign = val;
              });
            }}
            options={[
              {
                label: "Justify",
                value: "space-between",
                icon: <JustifyIcon width={"20px"} />,
                active: <JustifyActiveIcon width={"20px"} />,
              },
              {
                label: "Left",
                value: "left",
                icon: <LeftALignIcon width={"20px"} />,
                active: <LeftALignActiveIcon width={"20px"} />,
              },
              {
                label: "Center",
                value: "center",
                icon: <CenterAlignIcon width={"20px"} />,
                active: <CenterAlignActiveIcon width={"20px"} />,
              },
              {
                label: "Right",
                value: "right",
                icon: <RightAlignIcon width={"20px"} />,
                active: <RightAlignActiveIcon width={"20px"} />,
              },
            ]}
          />
          <ToggleInput
            resetValue={false}
            label="Open in new tab"
            value={openInNewTab}
            onChange={(val) => {
              setProp((props) => {
                props.openInNewTab = val;
              });
            }}
          />
          <ToggleInput
            resetValue={false}
            label="Show Label"
            value={showLabel}
            onChange={(val) => {
              setProp((props) => {
                props.showLabel = val;
              });
            }}
          />
          <ToggleInput
            resetValue={false}
            label="Is Social Share?"
            value={isSocialShare}
            onChange={(val) => {
              setProp((props) => {
                props.isSocialShare = val;
              });
            }}
          />
        </SpacerInput>
        {!isSocialShare && (
          <div className="bg-white mt-4 py-2 rounded-[21px] ">
            <Panel label={"Links"} isOpen={true}>
              <SpacerInput>
                {icons &&
                  icons.map((iconId, i) => {
                    return (
                      <TextInput
                        minLength={INPUT_LIMITS["social-links"].minlength}
                        maxLength={INPUT_LIMITS["social-links"].maxlength}
                        resetValue={undefined}
                        key={`${socialMedia[iconId]?.id}-${i}`}
                        value={links[socialMedia[iconId]?.id]}
                        onChange={(val) => {
                          var temp = { ...(links ? links : {}) };
                          temp[iconId] = val.target.value;
                          setProp((props) => {
                            props.links = temp;
                          });
                        }}
                        label={socialMedia[iconId]?.name}
                      />
                    );
                  })}
              </SpacerInput>
            </Panel>
          </div>
        )}
      </>
    );
  };

  const Styles = () => {
    return (
      <div className="w-full rounded-[21px] py-2 bg-white flex flex-col">
        <Panel label={"Colors"} isOpen={true}>
          <SpacerInput>
            <ColorInput
              value={color}
              onChange={(val) => {
                setProp((props) => {
                  props.color = val;
                });
              }}
              label={"Text"}
              useTextColorPalette={true}
            />
            <ColorInput
              value={backgroundColor}
              onChange={(val) => {
                setProp((props) => {
                  props.backgroundColor = val;
                });
              }}
              label={"Background"}
            />
          </SpacerInput>
        </Panel>
      </div>
    );
  };

  const Advance = () => {
    return (
      <div className="w-full rounded-[21px] py-2 bg-white flex flex-col">
        <Panel label={"Layout"} isOpen={true}>
          <SpacerInput>
            <PaddingInput
              label={"Padding"}
              value={layoutPadding}
              onChange={(val) => {
                setProp((props) => {
                  props.layoutPadding = val;
                });
              }}
            />
          </SpacerInput>
        </Panel>
      </div>
    );
  };

  const tabs = [
    {
      label: "General",
      key: "general",
      icon: IconPack.GeneralSettings,
      children: General(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Style",
      key: "style",
      icon: IconPack.Style,
      children: Styles(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Advanced",
      key: "advanced",
      icon: IconPack.Settings,
      children: Advance(),
      isUpdated: isUpdatedFromDefault([]),
    },
  ];

  return (
    <div className="h-full w-[330px] post-edit-right-sidebar p-2 overflow-auto dashboard-ui-scrollbar ">
      <div className="w-full rounded-t-[21px] bg-white">
        <div className="p-5 flex justify-between gap-5">
          <RightBar title={"Social Links"} icon={<StaplesActiveIcon />} />
        </div>

        <Tabs id={`block-cms-settings-tab-${id}`} items={tabs} />

        <div className="py-2 bg-ui-light-white"></div>
      </div>
    </div>
  );
};
